import type { InvoiceStatus, InvoiceType } from './invoicesTypes';

export type InvoiceSearchMatchField =
  | 'invoiceNumber'
  | 'buyer'
  | 'recipient'
  | 'searchTerm';

export interface InvoiceSearchMatch {
  field: InvoiceSearchMatchField;
  label: string;
}

export interface InvoiceSearchV2ListItem {
  id: number;
  invoiceNumber: string;
  issueDate: string;
  totalAmount: number;
  currency?: string | null;
  buyer: string;
  recipientName?: string | null;
  applicantFullName?: string | null;
  offerName?: string | null;
  type: InvoiceType;
  status: InvoiceStatus;
  searchMatches?: InvoiceSearchMatch[] | null;
}

export interface InvoiceSearchV2Request {
  searchTerm?: string;
  invoiceNumber?: string;
  issueDateFrom?: string;
  issueDateTo?: string;
  totalAmountFrom?: number;
  totalAmountTo?: number;
  buyer?: string;
  buyerAddress?: string;
  recipientName?: string;
  type?: InvoiceType;
  status?: InvoiceStatus;
  pageNumber: number;
  pageSize: number;
}

export interface InvoiceSearchV2Filters {
  searchTerm: string;
  invoiceNumber: string;
  issueDateFrom: string;
  issueDateTo: string;
  totalAmountFrom: string;
  totalAmountTo: string;
  buyerName: string;
  buyerAddress: string;
  recipientName: string;
  type: InvoiceType | '';
  status: InvoiceStatus | '';
}

export const defaultInvoiceSearchV2Filters: InvoiceSearchV2Filters = {
  searchTerm: '',
  invoiceNumber: '',
  issueDateFrom: '',
  issueDateTo: '',
  totalAmountFrom: '',
  totalAmountTo: '',
  buyerName: '',
  buyerAddress: '',
  recipientName: '',
  type: '',
  status: '',
};
